/* eslint-disable no-new */
import { ProductsFilterLinkDesktopClass } from "./products-filter-link-desktop-class";
import { ProductsFilterCollapseSectionsClass } from "./products-filter-collapse-sections-class";
import initModalWrapper from "./products-filter-modal-wrapper/products-filter-modal-wrapper";

export default () => {
  new ProductsFilterLinkDesktopClass({
    eventSelector: ".js-products-filter-desktop .js-products-filter-link"
  });

  new ProductsFilterCollapseSectionsClass({
    eventSelector: ".js-products-collapse-sections",
    linkedParam: "data-linked-section"
  });

  new ProductsFilterCollapseSectionsClass({
    eventSelector: ".js-products-collapse-categories",
    linkedParam: "data-linked-category-section"
  });

  initModalWrapper();
};
